/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
import Slider from "react-slick";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import splashImg1 from "../assets/img/onboarding_img_01.png";
import splashImg2 from "../assets/img/onboarding_img_02.png";
import splashImg3 from "../assets/img/onboarding_img_03.png";
import splashImg4 from "../assets/img/onboarding_img_04.png";
import splashImg5 from "../assets/img/onboarding_img_05.png";
import splashImg6 from "../assets/img/onboarding_img_06.png";
import setCookie from "../lib/client/setCookie";
import useScrollLock from "../lib/client/useScrollLock";

interface Splash2Types {
  isApp?: boolean;
}

function Splash2({ isApp }: Splash2Types) {
  // console.log("isApp?", isApp);
  const [dotsArr, setDotsArr] = useState<Array<number>>();
  const sliderRef = useRef<any>(null);
  const wrapperRef = useRef<any>(null);
  const [wrapperHeight, setWrapperHeight] = useState<any>();
  const [dots, setDots] = useState(0);
  const [splash, setSplash] = useState<boolean>(true);
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const forMobile = () => {
    const user = navigator.userAgent;
    if (user.indexOf("iPhone") > -1 || user.indexOf("Android") > -1) {
      setIsMobile(true);
    }
  };

  const settings = {
    // dots: true,
    infinite: false,
    autoplay: false,
    speed: 250,
    arrows: false,
    touchMove: true,
    slidesToShow: 1,
    cssEase: "linear",
    afterChange: function ss(index: any) {
      setDots(index);
    },
    slickGoTo(slideNumber: number) {
      setDots(slideNumber);
    },
  };

  const dotsHandler: Function = (index: number) => {
    setDots(index);
    sliderRef.current.slickGoTo(index);
  };

  const { lock, unlock } = useScrollLock();
  useEffect(() => {
    lock();
  }, []);

  const navigate = useNavigate();
  const doNotShowSplash: Function = () => {
    setCookie("isSplash", "true", 365);
    setSplash(false);
    unlock();
    navigate("/");
  };

  const slideToNextPage: Function = () => {
    sliderRef.current.slickGoTo(dots + 1);
  };

  useEffect(() => {
    const chkHeight = wrapperRef.current.offsetHeight;
    // console.log("헤이트 체크", chkHeight);
    setWrapperHeight(chkHeight);
    const number = 4;
    const setArr = [];
    for (let i = 0; i <= number; i++) {
      setArr.push(i);
    }
    setDotsArr(setArr);
    forMobile();
  }, [wrapperHeight]);

  const slideImgs = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const imgs = slideImgs.current;
    if (imgs) {
      const img = (
        <span className="splash-slider-img">
          <img src={splashImg2} alt="스플래시 슬라이더 이미지1" />
        </span>
      );
    }
  }, []);

  return (
    <div
      className="splash2-wrapper"
      ref={wrapperRef}
      style={splash ? { display: "block" } : { display: "none" }}
    >
      <p
        className={
          wrapperHeight < 741
            ? "splash-skip small"
            : wrapperHeight > 1000
            ? "splash-skip large"
            : "splash-skip medium"
        }
        id={
          wrapperHeight < 741
            ? "splash-skip small"
            : wrapperHeight > 1000
            ? "splash-skip large"
            : "splash-skip medium"
        }
        style={dots === 5 || dots === 0 ? { display: "none" } : {}}
        onClick={() => doNotShowSplash()}
      >
        SKIP
      </p>
      <div
        style={{
          height: "100%",
        }}
      >
        {dots !== 5 && (
          <ul
            className="splash2-dots"
            style={
              wrapperHeight < 741
                ? { top: "5%" }
                : wrapperHeight > 1000
                ? { top: "15%" }
                : { top: "10%" }
            }
          >
            {dotsArr &&
              dotsArr?.map((dot: number, index: number) => {
                return (
                  <li key={index}>
                    <button
                      type="button"
                      style={dots === dot ? { backgroundColor: "#212121" } : {}}
                      onClick={(e) => dotsHandler(dot)}
                      key={dot.toString()}
                    >
                      1
                    </button>
                  </li>
                );
              })}
          </ul>
        )}
        <Slider {...settings} ref={sliderRef}>
          <div className="splash2-content">
            <div className="splash-title">
              <p>명품 수선 유목민 생활은</p>
              <p>이제 그만.</p>
            </div>
            <div style={{ width: "306px", margin: "100px auto 100px" }}>
              <img
                src={splashImg1}
                alt="명품 수선사 추천 이미지"
                style={{ width: "100%", display: "block" }}
              />
              <div className="splash-sub-title" style={{ marginTop: "4px" }}>
                <p>손품, 발품 팔지 않아도</p>
                <p>원하는 수선정보가 모두 럭셔리앤올에</p>
              </div>
            </div>
            <div className="splash-desc">
              <p>힘들었던 명품 수선 생활,</p>
              <p
                style={{
                  fontFamily: "Pretendard-Bold",
                }}
              >
                럭셔리앤올이 바꿉니다
              </p>
            </div>
            <div className="splash2-button">
              <button
                type="button"
                style={{ marginTop: "27px" }}
                onClick={() => slideToNextPage()}
              >
                살펴보기
              </button>
            </div>
          </div>
          <div className="splash2-content">
            <div className="splash-title">
              <p style={{ color: "#6c40ff" }}>럭셔리앤올이 검증한</p>
              <p>명품 수선사들을 만나보세요</p>
            </div>
            <div className="splash-animation">
              <div className="splash-imgs" ref={slideImgs}>
                <span className="splash-slider-img">
                  <img src={splashImg2} alt="스플래시 슬라이더 이미지1" />
                </span>
                <span className="splash-slider-img">
                  <img src={splashImg2} alt="스플래시 슬라이더 이미지1" />
                </span>
                <span className="splash-slider-img">
                  <img src={splashImg2} alt="스플래시 슬라이더 이미지1" />
                </span>
                <span className="splash-slider-img">
                  <img src={splashImg2} alt="스플래시 슬라이더 이미지1" />
                </span>
                <span className="splash-slider-img">
                  <img src={splashImg2} alt="스플래시 슬라이더 이미지1" />
                </span>
                <span className="splash-slider-img">
                  <img src={splashImg2} alt="스플래시 슬라이더 이미지1" />
                </span>
                <span className="splash-slider-img">
                  <img src={splashImg2} alt="스플래시 슬라이더 이미지1" />
                </span>
                <span className="splash-slider-img">
                  <img src={splashImg2} alt="스플래시 슬라이더 이미지1" />
                </span>
                <span className="splash-slider-img">
                  <img src={splashImg2} alt="스플래시 슬라이더 이미지1" />
                </span>
                <span className="splash-slider-img">
                  <img src={splashImg2} alt="스플래시 슬라이더 이미지1" />
                </span>
              </div>
            </div>
            <div className="splash2-button">
              <button type="button" onClick={() => slideToNextPage()}>
                다음 <span className="arrow" />
              </button>
            </div>
          </div>
          <div className="splash2-content">
            <div className="splash-title">
              <p>사진만 있으면</p>
              <p>
                <span style={{ color: "#6c40ff" }}>무료</span>로 견적을
                제안드립니다
              </p>
            </div>
            <div style={{ width: "360px", margin: "0 auto" }}>
              <img
                src={splashImg3}
                alt="명품 수선사 추천 이미지"
                style={{ width: "100%", display: "block" }}
              />
            </div>
            <div className="splash2-button">
              <button type="button" onClick={() => slideToNextPage()}>
                다음 <span className="arrow" />
              </button>
            </div>
          </div>
          <div className="splash2-content">
            <div className="splash-title">
              <p>
                수선사의{" "}
                <span style={{ color: "#6c40ff" }}>실력,가격,기간</span>을
              </p>
              <p>한눈에</p>
            </div>
            <div style={{ width: "360px", margin: "0 auto" }}>
              <img
                src={splashImg4}
                alt="명품 수선사 추천 이미지"
                style={{ width: "100%", display: "block" }}
              />
            </div>
            <div className="splash2-button">
              <button type="button" onClick={() => slideToNextPage()}>
                다음 <span className="arrow" />
              </button>
            </div>
          </div>
          <div className="splash2-content">
            <div className="splash-title">
              <p>
                <span style={{ color: "#6c40ff" }}>수선과 클리닝</span>까지
              </p>
              <p>모두 여기서</p>
            </div>
            <div style={{ width: "360px", margin: "0 auto" }}>
              <img
                src={splashImg5}
                alt="명품 수선사 추천 이미지"
                style={{ width: "100%", display: "block" }}
              />
            </div>
            <div className="splash2-button">
              <button type="button" onClick={() => slideToNextPage()}>
                다음 <span className="arrow" />
              </button>
            </div>
          </div>
          <div className="splash2-content bg-uniq">
            <div className="splash-title">
              <p
                style={{
                  color: "#fff",
                  fontFamily: "Pretendard-Regular",
                  marginTop: "-24px",
                  lineHeight: "36px",
                  letterSpacing: "-4%",
                  fontSize: "24px",
                }}
              >
                알아서 다 되는 명품케어
              </p>
              <p>
                <span
                  style={{
                    fontFamily: "Pretendard-Bold",
                    fontSize: "36px",
                    color: "#fff",
                    lineHeight: "54px",
                    letterSpacing: "-4%",
                  }}
                >
                  럭셔리앤올
                </span>
              </p>
            </div>
            <div style={{ width: "300px", margin: "33px auto 0" }}>
              <img
                src={splashImg6}
                alt="명품 수선사 추천 이미지"
                style={{ width: "100%", display: "block" }}
              />
            </div>
            <div
              className="splash2-button"
              id="splash2-button"
              style={{ marginTop: "-16px" }}
            >
              <button
                style={{ backgroundColor: "#6c40ff" }}
                type="button"
                onClick={() => doNotShowSplash()}
              >
                명품 수선/케어 시작하기
              </button>
            </div>
          </div>
        </Slider>
      </div>
    </div>
  );
}

export default Splash2;
